

































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import countryHelper from "../../util/countries";
import {Country} from "@/interfaces/Country";
import {Region} from "@/store/countriesStore";
import Inputfield from "@/components/partials/Inputfield.vue";

@Component({
    components: {Inputfield}
})


export default class CountryPicker extends Vue {

    @Prop({type: String, default: ""}) currentCountryCode?: string;
    @Prop({ type: Boolean, default: false }) readonly restrictCountries!: boolean;
    private selectedCountry?: Country | null;
    private countryInput: string = "";
    private showProposals: boolean = false;
    private countryProposal: Array<Country> = [];
    private isLoading: boolean = true;

    mounted(){
        this.setCurrentCountry();
    }

    @Watch("countryInput")
    async countryChanged(val: string) {
        if(!val || (this.countryProposal && this.countryProposal.find((prop: Country) => prop.name === val))) {
            return this.countryProposal = [];
        }
        this.countryProposal = this.allCountries.filter((item: Country) => {
            const queryInLowerCase = this.countryInput.toLocaleLowerCase();
            return item.name.toLocaleLowerCase().includes(queryInLowerCase);
        });
    }

    private async proposalSelect(country: Country) {
        if(!country || !country.name) return;

        if (this.isRestricted(country.code)) {
            // block selection and notify parent
            this.$emit("restrictedCountry", country);
            // keep input text (so user sees what they tried)
        }

        this.selectedCountry = country;
        this.countryInput = country.name;
        this.$emit("change",this.selectedCountry);
    }

    private inputSelect() {
        this.showProposals = false;
        this.selectedCountry = this.allCountries.find((country: Country) => {
            return country.name === this.countryInput;
        });
        if(!this.selectedCountry && this.countryInput !== ""){
            this.$emit("incorrectInput", this.countryInput);
            return;
        }
        if (this.selectedCountry && this.isRestricted(this.selectedCountry.code)) {
            this.$emit("restrictedCountry", this.selectedCountry);
            return;
        }
        this.$emit("change",this.selectedCountry);
    }

    private clearInputfield() {
        this.selectedCountry = null;
        this.countryInput = "";
        this.$emit("change",this.selectedCountry);
    }

    private restrictedCountryCodes(): Array<string> {
        const restrictedCountryString: string = process.env.VUE_APP_RESTRICTED_COUNTRIES || "";
        // string to array

        return  restrictedCountryString.split(",").map((code: string) => code.trim());
    }

    private isRestricted(code?: string): boolean {
        return this.restrictCountries && !!code && this.restrictedCountryCodes().includes(code);
    }


    countryName(): string {
        return this.selectedCountry ? this.selectedCountry.name : "";
    }

    get allCountryCodes(): Array<string> {
        const countryCodes: Array<string>= [];
        const regions = this.$store.state.regions;
        regions.forEach((region: Region) => {
            region.countries.forEach((code: string) => {
                countryCodes.push(code);
            });
        });
        return countryCodes;
    }

    get allCountries(): Array<Country> {
        const countries = this.allCountryCodes.map((code: string) => ({
            code: code,
            name: countryHelper.getCountryName(code)
        }));
        return countries.sort((countryA: Country, countryB: Country) => {
            if (countryA.name < countryB.name) return -1;
            if (countryA.name > countryB.name) return 1;
            return 0;
        });
    }

    setCurrentCountry() {
        this.isLoading = true;
        if (this.currentCountryCode) {
            const currentCountry = this.allCountries.find((country: Country) => {
                return country.code === this.currentCountryCode;
            });
            if (currentCountry) {
                this.selectedCountry = currentCountry;
                this.$emit("change",this.selectedCountry);
                this.countryInput = this.selectedCountry.name;
            }
            else this.countryInput = "";
        }
        this.isLoading = false;
    }

    countryValidator(countryName: string): boolean {
        const found = this.allCountries.find((c: Country) => c.name === countryName);
        if (!found) return false;

        if (this.isRestricted(found.code)) {
            this.$emit("restrictedCountry", found);
            return false; // makes Inputfield show its error
        }

        return true;
    }
}
